import secureApi from "../services/secureApi";

export const loginWithEmailApi = async (payload) => {
  try {
    const response = await secureApi.post("/admin/login", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logoutApi = async () => {
  try {
    const response = await secureApi.put("/admin/logout");
    return response.data;
  } catch (error) {
    throw error;
  }
};